import { mapValues } from '../../../lib/utilities';
import { updateFiltersAction } from '../../_flux/actions/catalog_filter_actions';
import {
    setValuesAction as setConfiguratorValuesAction,
    setBackupValuesAction as setConfiguratorBackupValuesAction,
    showSecondLayerAction
} from '../../_flux/actions/catalog_configurator_actions';
import { updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import { updateAvailableFilterOptionsAction } from '../../_flux/actions/filter_available_options_actions';
import { setCatalogItemsAction } from '../../_flux/actions/catalog_items_actions';
import { setCatalogPromotionsAction } from '../../_flux/actions/catalog_promotions_actions';
import { enableOptionAction } from '../../_flux/actions/catalog_conditional_options_actions';
import {
    setFilter as setProvisionalFilter,
    setSectionFilter
} from '../../_flux/actions/catalog_filter_provisional_filter_actions';
import { setSortingAction, setSortingOptionsAction } from '../../_flux/actions/catalog_sorting_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import { getPriceOptions } from '../../_flux/helper/get_price_options';
import { replaceWithOptionalFilterLabelTranslation } from '../../_modules/translation/replace_with_optional_filter_label_translation';
import { formatFilterDefaultLabel } from '../../_modules/filter/format_filter_default_label';
import { postcodeExistsButNeedsToBeLoaded } from '../../_flux/actions/postcode_actions';
import { forOwn } from '../../../lib/utilities';
import { getValue } from '../../utilities/local_storage';
import { setCatalogAdsAction } from '../../_flux/actions/catalog_ads_actions';
import API from '../../API/api';
import { shippingAdRequest } from '../../_flux/components/product/shipping_request';
import { loadAdCatalog } from '../../_modules/google_analytics/product/product_tiles';

export function getDefaultLabelFormattingConfig(filterName) {
    switch (filterName) {
        case Filters.MANUFACTURER:
        case Filters.MODEL:
            return {
                upperCaseFirstAll: true,
            };

        default:
            return {};
    }
}

function setInitialState(loadOnlyAds) {
    const catalogAdsContainer = document.querySelector('#catalog-ads-container, #catalog-revamp-ads-container, #cms-ads-product');
    if (catalogAdsContainer) {
        getAdsData();
    }

    if (!loadOnlyAds) {
        const statusbarState = TYROOLA.initialFluxStates.statusbar;
        statusbarState.region = getValue('shippingState');
        const filters = { ...TYROOLA.initialFluxStates.filter.activeFilters, [Filters.POSTCODE]: getValue('shippingPostcode') || '' };
        const sorting = TYROOLA.initialFluxStates.sorting;

        if (TYROOLA.initialFluxStates.filter.hasPostcode) {
            postcodeExistsButNeedsToBeLoaded();
        }

        updateFiltersAction({ ...filters, region: statusbarState.region });

        setProvisionalFilter(filters);
        setSectionFilter(filters);
        setConfiguratorValuesAction(filters);
        setConfiguratorBackupValuesAction(filters);

        setSortingAction(sorting.currentSorting.sorting, sorting.currentSorting.direction);
        setSortingOptionsAction(sorting.options);

        setCatalogItemsAction(TYROOLA.initialFluxStates.products);
        setCatalogPromotionsAction(TYROOLA.initialFluxStates.promotions);

        updateAvailableFilterOptionsAction(TYROOLA.initialFluxStates.filter.availableOptions);

        forOwn(TYROOLA.initialFluxStates.filter.enabledOptions, (isEnabled, filterName) => {
            if (isEnabled) {
                enableOptionAction(filterName);
            }
        });

        updateFilterOptionsAction(Object.assign(
            {},
            mapValues(TYROOLA.initialFluxStates.filter.filterOptions, ((filterOption, filterName) => {
                if (!Array.isArray(filterOption)) {
                    return filterOption;
                }

                return filterOption.map(option => {
                    const [value, label] = option;
                    const defaultLabelFormattingConfig = getDefaultLabelFormattingConfig(filterName);
                    const defaultLabel = formatFilterDefaultLabel(label, defaultLabelFormattingConfig);
                    const formattedLabel = replaceWithOptionalFilterLabelTranslation(value, defaultLabel);

                    return [value, formattedLabel];
                });
            })),
            {
                [Filters.PRICE_MIN]: getPriceOptions(20000000, TYROOLA.globals.currencyIsoCode),
                [Filters.PRICE_MAX]: getPriceOptions(20000000, TYROOLA.globals.currencyIsoCode, true)
            }
        ));

        if (filters.width && filters.height && filters.diameter) {
            showSecondLayerAction();
        }
    }
}

function getAdsData() {
    const addressTypeEnum = Object.freeze({
        RESIDENTIAL: 'residential',
        BUSINESS: 'business'
    });

    const adsData = {
        displayUrl: location.pathname,
        addressShipping: {
            addressType: addressTypeEnum.BUSINESS,
        },
    };

    API.POST({
        apiPath: `/api/v2/ads/`,
        data: JSON.stringify(adsData),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
    })
        .done((res) => {
            if (res && res.ad) {
                const data = {
                    ...res.product,
                    ...res.ad,
                    url: res.ad.targetUrl || res.product.url,
                };
                setCatalogAdsAction([data]);
                loadAdCatalog(data);

                const shippingAdProduct = [{ sku: res.product.sku }];
                const shippingAdQuantity = (data.stock < 4 ? [data.stock] : [4]);
                shippingAdRequest(shippingAdProduct, shippingAdQuantity, 3);
            } else {
                const catalogAdsContainer = document.querySelector('#catalog-ads-container, #catalog-revamp-ads-container');
                if (catalogAdsContainer) {
                    catalogAdsContainer.style.display = 'none';
                }
            }
        })
        .catch((err) => {
            console.log(err);
        });
}

export { setInitialState };
